import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import useMediaQuery from '../../../utils/useMediaQuery'
import arrow from '../../../assets/images/awards/arrow.svg'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './contentSomeTips.scss'

const ContentSomeTips = () => {
  const [actualSlide, setActualSlide] = React.useState(0)
  const isMobile = useMediaQuery()

  const {
    icon_1: { childImageSharp: icon_1 },
    icon_2: { childImageSharp: icon_2 },
    icon_3: { childImageSharp: icon_3 },
    icon_4: { childImageSharp: icon_4 },
    icon_5: { childImageSharp: icon_5 },
  } = useStaticQuery(graphql`
    {
      icon_1: file(name: { eq: "icono-1" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      icon_2: file(name: { eq: "icono-2" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      icon_3: file(name: { eq: "icono-3" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      icon_4: file(name: { eq: "icono-4" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      icon_5: file(name: { eq: "icono-5" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const cardInfo = [
    {
      img: icon_1,
      txt: (
        <>
          <b>Corre la voz,</b> comparte la seguridad y confianza con personas
          que no conozcas, puedes hacer muestreo en un parque cercano o tu
          barrio.
        </>
      ),
    },
    {
      img: icon_2,
      txt: (
        <>
          <b>Enfócate en los beneficios de la tecnología </b>y lo que la hace
          únicas a nuestras Toallas para el día con Tecnología Cur-V
        </>
      ),
    },
    {
      img: icon_3,
      txt: (
        <>
          <b>No te quedes solo con un formato,</b> prueba con fotografías,
          videos, reels, dibujos, etc. Muestrános tu esencia en todas las
          maneras y no olvides registrar tus links en la sección Tu misión.
        </>
      ),
    },
    {
      img: icon_4,
      txt: (
        <>
          Para tus reels{' '}
          <b>usa los audios y canciones que estén en tendencia </b> y sean
          originales ¡¡Así mejorará el alcance de tus videos y si apareces en el
          sabemos que tendrá muchas posibilidades de ser súper exitoso!!
        </>
      ),
    },
    {
      img: icon_5,
      txt: (
        <>
          Es súper importante que{' '}
          <b> tu perfil esté público, además usa HASHTAG </b>
          relacionados con el contenido que subas para que más personas te
          conozcan, por ejemplo: #menstruacion #ciclomenstrual #fyp #girlpower
        </>
      ),
    },
  ]

  const ArrowSlide = ({ direction, onClick }) => {
    return (
      <button className={`f-arrow-slide ${direction}`} onClick={onClick}>
        <img src={arrow} alt="flecha slide" />
      </button>
    )
  }
  const settingsSlider = {
    dots: false,
    infinite: true,
    nextArrow: <ArrowSlide direction="right" />,
    prevArrow: <ArrowSlide direction="left" />,
    speed: 500,
    slidesToShow: 2.99,
    slidesToScroll: 1,
    className: 'center',
    centerMode: true,
    centerPadding: '10px',
    beforeChange: (current, next) => {
      setActualSlide(next)
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <section className="f-someTips-container">
      <div className="f-someTips-container__wrapper">
        <h1>¡Algunos tips!</h1>
        <div className="f-someTips-container__cardsTips">
          {isMobile ? (
            <Slider {...settingsSlider}>
              {cardInfo.map((item, index) => {
                return (
                  <div
                    className="f-someTips-container__cardsTips__cardTip"
                    key={index}
                  >
                    <GatsbyImage
                      objectFit="cover"
                      image={getImage(item.img)}
                      alt="iconos de informacion de tips"
                      className="f-someTips-container__cardsTips__cardTip__imgIcon"
                    />
                    <p>{item.txt}</p>
                  </div>
                )
              })}
            </Slider>
          ) : (
            cardInfo.map((item, index) => {
              return (
                <div
                  className="f-someTips-container__cardsTips__cardTip"
                  key={index}
                >
                  <GatsbyImage
                    objectFit="cover"
                    image={getImage(item.img)}
                    alt="iconos de informacion de tips"
                    className="f-someTips-container__cardsTips__cardTip__imgIcon"
                  />
                  <p>{item.txt}</p>
                </div>
              )
            })
          )}
        </div>
      </div>
    </section>
  )
}

export default ContentSomeTips
